import type { AsyncItem } from "owa-copilot-async-chat-types";

/**
 * The text identifying an async item across surfaces.
 *
 * While a turn is running the item shows the request that started it. Once the turn settles it
 * shows the generated title, falling back to the prompt.
 *
 * Every item is expected to have one or the other: a title once its first turn settles, and a
 * prompt before that. The empty string is a defensive floor for an item that somehow has neither,
 * where the status rendered alongside the label is what identifies it.
 */
export function getAsyncItemLabel(item: AsyncItem): string {
    if (item.status === "Working" && item.prompt) {
        return item.prompt;
    }
    return item.title || item.prompt || "";
}
